import * as React from "react";

function ChevronDown(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 8" fill="none" {...props}>
      <path
        d="M7 5.078l4.95-4.95 1.414 1.414L7 7.906.636 1.542 2.05.128 7 5.078z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoChevronDown = React.memo(ChevronDown);
export default MemoChevronDown;
